import isEmpty from 'lodash/isEmpty';

import { PAYEX_URL } from 'constants/config';
import type { Field } from 'models/field';
import type { Payment } from 'models/payment';
import { fetchJson, fetchWithAuthentication } from 'utils/fetchJson/fetchJson';
import type { I18n } from 'utils/translations/translations';
import { translateFields } from './translator';
import type { FetchAcademicParams, SaveAcademicParams } from './types';

export const academic = {
  fetch: async (
    { recipient, required }: FetchAcademicParams,
    { i18n }: { i18n: I18n },
  ) => {
    const path = `${PAYEX_URL}/academic_fields?recipient_id=${recipient}&is_required=${required}`;
    const data = await fetchJson<{ fields?: Field[] }>(path);
    if (!isEmpty(data)) {
      const translatedFields = translateFields(data.fields!, i18n);
      return { fields: translatedFields };
    }

    return { fields: [] };
  },

  save: ({ token, payload }: SaveAcademicParams): Promise<Payment> => {
    const body = JSON.stringify(payload);
    const options = { method: 'POST', body };

    const path = `${PAYEX_URL}/academic_fields?token=${token}`;
    return fetchWithAuthentication(path, options);
  },
};
